import { useMemo, useState } from "react"
import { sendStartCode } from "../../../api"
import { useAction, useAppState } from "../../../hooks"
import { EInfoMessageType } from "../../../types"
import { GAMES, gameType } from "../../../utils"
import { Heading, Input, Section } from "../../page"

import './start.scss'

type StartProps = {
    setLoading: any,
    refreshUser: any
}

export const Start = ({ setLoading, refreshUser }: StartProps) => {

    const [code, setCode] = useState('')
    const [codeError, setCodeError] = useState('')

    const { state } = useAppState()
    const { setInfoMessageAction } = useAction()

    const startGame = () => {
        setCodeError('')
        if (code.length < 1) {
            setCodeError('Vyplňte startovní kód! Najdete jej v Průvodci')
            return
        }
        if (state?.token) {
            setLoading(true)
            sendStartCode({ code: code, token: state.token }).then((res) => {
                console.log(res)
                if (res.sucessMessage) {
                    setInfoMessageAction({ type: EInfoMessageType.SUCCESS, message: res.sucessMessage, timeout: 60 })
                    refreshUser()
                } else if (res.errorMessage) {
                    console.log('ERROR')
                    console.log(res.errorMessage)
                    setInfoMessageAction({ type: EInfoMessageType.ERROR, message: res.errorMessage, timeout: 20 })
                }
            }).finally(() => { setLoading(false) })
        }
    }

    const StartInstructionsSift = () => {
        return (
            <>
                <Heading headline={`ŠifT 2024`} weight={2} centered={true} />
                <Section>
                    {
                        <>
                            <p>Obálku se šiframi otevřte až po signálu od organizátorů! V obálce najdete první šifru, její jméno bezprodleně vložte do následujícího pole (čas se počítá od 9:00 bez ohledu na přesný čas zadání, ale prosím, zadejte jej co nejrychleji).</p>
                            <p>Zkontrolujte si, že vás websystém zařadil do správné kategorie:
                                <ul>
                                    <li>Začátečníci mají záhlaví <span className='blue'>modré</span>,</li>
                                    <li>Pokročilí mají záhlaví <span className='red'>červené</span>.</li>
                                </ul>
                            </p>
                        </>
                    }
                </Section>

            </>
        )
    }

    const StartInstructionsZkratka = () => {
        return (
            <>
                <Heading headline={`Zkratka 2024`} weight={2} centered={true} />
                <Section>
                    {
                        <>
                            <p>Vítejte na startu Zkratky 2024!</p>
                            <p>V této chvíli byste měli mít přečteného Průvodce Zkratkou. Pokud jste tak ještě neučinili, pusťe se do čtení!</p>
                            <p>Obálku, kterou jste dostali od organizátorů, <strong>otevřete až na pokyn kolem 8:30!</strong></p>
                            <p>Už teď můžete zadat startovní kód z Průvodce a pustit se do řešení bonusové šifry, kterou v něm najdete. Čas hry se počítá nezávisle na přesném času zadání startovního kódu.</p>
                        </>
                    }

                </Section>

            </>
        )
    }

    const StartInstructionsTest = () => {
        return (
            <>
                <Heading headline={`Zkratka 2024 - test`} weight={2} centered={true} />
                <Section>
                    {
                        <>
                            <p>Vítejte v testovacéím websystému!</p>
                            
                            <p>Doporučujeme testovat ze zařízení, které budete mít s sebou na hře (a případně vyzkoušet, které vám nejlépe reaguje). Začněte zadáním kódu TEST.</p>
                        </>
                    }

                </Section>

            </>
        )
    }

    const renderInstructions = useMemo(() => {
        switch (gameType()) {
            case GAMES.SIFT:
                return <StartInstructionsSift />
            case GAMES.ZKRATKA:
                return <StartInstructionsZkratka />
            case GAMES.HIDDEN:
                return <StartInstructionsTest />
            default:
                return <></>;
        }
    }, [code, codeError, state]);

    function getStartButtonLabel() {
        switch (gameType()) {
            case GAMES.SIFT:
                return 'Jméno šifry:'
            case GAMES.ZKRATKA:
                return 'Kód z průvodce:'
            case GAMES.HIDDEN:
                return 'Kód:'
            default:
                return '';
        }
    }


    return (
        <>

            {renderInstructions}

            <Section>
                <div className='startCode'>
                    <div className='startCode__code'>
                        <Input
                            label={getStartButtonLabel()}
                            value={code}
                            setValue={e => setCode(e.target.value)}
                            errorMessage={codeError}
                            type='text'
                        />
                    </div>
                    <div className='startCode__send'>
                        <button className='button' onClick={startGame}>Odeslat</button>
                    </div>
                </div>
            </Section>
        </>
    )
}